export class TimeUnits {
    private static SECOND = 1000;
    private static MINUTE = 60 * TimeUnits.SECOND;
    private static HOUR = 60 * TimeUnits.MINUTE;
    private static DAY = 24 * TimeUnits.HOUR;

    private unit: number;
    private no: number;

    public static Minues(no: number) {
        return new TimeUnits(TimeUnits.MINUTE, no);
    }
    public static Hours(no: number) {
        return new TimeUnits(TimeUnits.HOUR, no);
    }
    public static Days(no: number) {
        return new TimeUnits(TimeUnits.DAY, no);
    }

    public toMilis() {
        return this.no * this.unit;
    }
    private constructor(timeUnit: number, no: number) {
        this.unit = timeUnit;
        this.no = no;
    }
}

export class Dates {
    public static monthStartDate(monthRelative: number): Date {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth() + monthRelative, 1, 0, 0, 0, 0);
    }

    public static monthFinishDate(monthRelative: number): Date {
        const now = new Date();
        const targetMonthEndDate = new Date(now.getFullYear(), now.getMonth() + monthRelative + 1, 1, 0, 0, 0, 0);
        return new Date(targetMonthEndDate.getTime() - 1);
    }
    public static startTime(dateStr: string): Date {
      let regExp = /(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})\s+((\d{1,2}):(\d{1,2}))?$/;
      let parsed = regExp.exec(dateStr);
      if (!parsed) {
        regExp = /(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/;
        parsed = regExp.exec(dateStr);
      }
      if(!parsed)
        return null

      const day = Number(parsed[1]);
      const month = Number(parsed[2]);
      const year = Number(parsed[3]);

      let hour = Number(parsed[5]) ? Number(parsed[5]) : 0;
      let minute = Number(parsed[6]) ? Number(parsed[6]) : 0;

      return new Date(year, month - 1, day, hour, minute, 0, 0);
    }

    public static finishTime(dateStr: string): Date {
        let regExp = /(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})\s+((\d{1,2}):(\d{1,2}))?$/;
        let parsed = regExp.exec(dateStr);
        if (!parsed) {
          regExp = /(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/;
          parsed = regExp.exec(dateStr);
        }
        if(!parsed)
          return null

        const day = Number(parsed[1]);
        const month = Number(parsed[2]);
        const year = Number(parsed[3]);

        let hour = Number(parsed[5]) ? Number(parsed[5]) : 0;
        let minute = Number(parsed[6]) ? Number(parsed[6]) : 0;
        return hour? new Date(year, month - 1, day, hour, minute, 0, 0) : new Date((new Date(year, month - 1, day + 1, 0, 0, 0, 0)).getTime() - 1)
    }

    public static simpleDateTimeParse(dateStr: string): Date {
        const regExp = /(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})\s+((\d{1,2}):(\d{1,2}))?$/gm;
        const parsed = regExp.exec(dateStr);
        if (!parsed) {
            return null;
        }
        const day = Number(parsed[1]);
        const month = Number(parsed[2]);
        const year = Number(parsed[3]);
        let hour = 0;
        let minute = 0;

        if (parsed[4]) {
            hour = Number(parsed[5]);
            minute = Number(parsed[6]);
        }

        return new Date(year, month - 1, day, hour, minute, 0, 0);
    }

    public static simpleDateFormat(date: Date): string {
        if (!date) {
            return '';
        }

        return date.getDate().toString().padStart(2, '0')
        + '/'
        +  (date.getMonth() + 1).toString().padStart(2, '0')
        + '/'
        + date.getFullYear()
        + ' '
        + date.getHours().toString().padStart(2, '0')
        + ':'
        + date.getMinutes().toString().padStart(2, '0');
    }

    public static parse(date: string): Date {
        if (date == null ) { return null; }
        if (date === 'null') { return null; }
        const regExp = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})([+\-])?(\d{2}):?(\d{2})/gm;
        const parsed = regExp.exec(date);

        const year = Number(parsed[1]);
        const month = Number(parsed[2]) - 1;
        const day = Number(parsed[3]);
        const hour = Number(parsed[4]);
        const minute = Number(parsed[5]);
        const second = Number(parsed[6]);
        const mili = Number(parsed[7]);
        const timezoneSign = parsed[8];
        const timezoneHour = Number(parsed[9]);
        const timezoneMinute = Number(parsed[10]);

        let offset = TimeUnits.Hours(timezoneHour).toMilis() + TimeUnits.Minues(timezoneMinute).toMilis();
        if (timezoneSign === '-') {
            offset = -offset;
        }

        offset = -offset;

        const utcDate = Date.UTC(year, month, day, hour, minute, second, mili) + offset;
        return new Date(utcDate);
    }

    public static getWeekStartDate(focusDate: Date) {
        let weekStart = new Date((focusDate).getTime() - new Date().getDay() * 24 * 60 * 60 * 1000)
        weekStart.setHours(0)
        weekStart.setMinutes(0)
        weekStart.setSeconds(0)
        weekStart.setMilliseconds(0)
        return weekStart
    }
}

